<template>
    <div>

        <p class="mt-6 has-text-white" v-if="loading"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading available content...</p>

        <section v-else>
            <div class="columns" v-if="ondemandSessions.length > 0">
                <div class="column is-12">
                    <ui-card v-for="session in ondemandSessions" class="mb-5">
                        <div class="columns" v-if="session.media">
                            <div class="column is-narrow">
                                <div class="video-frame">
                                    <img :src="session.media.thumbnail"/>
                                </div>
                            </div>
                            <div class="column pt-4">
                                <div class="columns is-gapless mb-3">
                                    <div class="column is-narrow is-size-4"><i class="fad mr-4 fa-clapperboard-play has-text-primary"></i></div>
                                    <div class="column">
                                        <h6 class="pt-1">{{session.title}}</h6>

                                        <div v-html="session.description" class="is-size-7 mb-4"></div>
                                        <div class="is-size-7 has-text-grey-dark" v-if="session.presenter"><i class="fad fa-fw fa-person-chalkboard mr-2"></i>{{session.presenter}}</div>
                                        <div class="is-size-7 has-text-grey-dark" v-if="((session.media.duration/1000) < 3600)"><i class="far fa-clock mr-2"></i>00:{{(session.media.duration/1000) | moment('utc', 'mm:ss')}}</div>
                                        <div class="is-size-7 has-text-grey-dark" v-else><i class="fad fa-fw fa-clock mr-2"></i>{{(session.media.duration/1000) | moment('utc', 'H:mm:ss')}}</div>

                                        <div class="mt-3 has-text-warning has-text-weight-bold" v-if="!session.is_active"><i class="far fa-clock-rotate-left mr-2"/>This On-Demand Content has expired and is no longer available.</div>

                                        <div class="mt-4" v-if="session.recorded_time">
                                            <section v-if="session.recorded_minutes < session.max_log_minutes">
                                                <b-progress class="session-progress mb-1 pb-0" size="is-small" type="is-primary" :value="session.recorded_minutes" :max="session.max_log_minutes"></b-progress>
                                                <div class="is-size-7 has-text-grey-dark">You have recorded {{session.recorded_minutes*60 | moment('utc', 'HH:mm')}} of the maximum of {{session.max_log_minutes * 60 | moment('utc', 'HH:mm')}} qualified time. Details on your <router-link :to="{name: 'record-log'}"><i class="fad fa-clipboard-check"></i> Record & Attendance Log</router-link>.</div>
                                            </section>
                                            <section v-else>
                                                <div class="is-size-7 has-text-grey-dark"><i class="fad fa-fw fa-check has-text-success mr-2"></i>You have recorded the maximum amount of qualified time for this session. Details on your <router-link :to="{name: 'record-log'}"><i class="fad fa-clipboard-check"></i> Record & Attendance Log</router-link>.</div>
                                            </section>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="column has-text-right is-narrow pl-6">
                                <b-button type="is-primary" disabled v-if="registration.is_po_pending || !session.is_active"><i class="fas fa-play mr-2"></i>View Content</b-button>
                                <router-link :to="{name: 'on-demand-content', params: {registrationId: registrationId, sessionId: session.id}}" v-else>
                                    <b-button type="is-primary"><i class="fas fa-play mr-2"></i>View Content</b-button>
                                </router-link>
                            </div>
                        </div>
                        <div v-else>
                            <h6 class="pt-1">{{session.title}}</h6>
                            <div class="is-size-7 has-text-grey-dark">
                                <i class="far fa-exclamation-triangle mr-2 ml-1 has-text-warning"></i>This content has not been properly configured and is currently not available.
                            </div>
                        </div>
                    </ui-card>
                </div>
            </div>
            <section v-else>
                <ui-card class="pt-4 pl-4 pr-6">
                    <div class="columns is-gapless mb-6 pt-5">
                        <div class="column is-narrow is-size-5"><i class="far fa-fw fa-info-circle mr-4"></i></div>
                        <div class="column">
                            <div class="has-text-weight-bold is-size-5">There is no On-Demand Content currently available for this conference.</div>
                            <div class="mt-4 pr-6">
                                On-Demand Content may be added later or the content has expired and is no long available. If this is a live conference then On-Demand Content may not be posted until the sessions have concluded and have been processed. Please contact the event organizer for more information.
                            </div>
                            <div class="mt-4 pr-6 has-text-weight-bold">
                                <i class="far fa-fw fa-arrow-right mr-2"></i>Please, check back later!
                            </div>
                        </div>
                    </div>
                </ui-card>
            </section>
        </section>


    </div>
</template>

<script>
    import {client as http} from "../../../http_client";
    import moment from "moment";
    import UiCard from "../../../components/UiCard";

    export default {
        components: {UiCard},
        props: ['registrationId'],
        data: function() {
            return {
                registration: {
                    conference: {
                        sessions: []
                    }
                },
                loading: true
            };
        },
        computed: {
            ondemandSessions: function() {
                return this.registration.conference.sessions.filter(session => session.type === 'on-demand');
            }
        },
        methods: {
            loadRegistration: function(force) {
                http.get('app/registrations/' + this.registrationId, {force}).then(response => {
                    this.registration = response.data;
                    this.loading = false;

                    this.registration.conference.sessions.sort((a, b) => {
                        if (a.title < b.title) {
                            return -1;
                        }
                        if (a.title > b.title) {
                            return 1;
                        }
                        return 0;
                    });

                    // Sum up log minutes and time for each session
                    let logTotalsBySession = {};
                    this.registration.reg_record_log.forEach(log => {
                        if (!logTotalsBySession[log.session_id]) {
                            logTotalsBySession[log.session_id] = {
                                minutes: 0,
                                time: 0
                            };
                        }
                        if (log.minutes > 0) {
                            logTotalsBySession[log.session_id].minutes += log.minutes;
                            logTotalsBySession[log.session_id].time += log.time;
                        }
                    });

                    // assign the total recorded time and minutes to each session for progress bars
                    this.registration.conference.sessions.forEach(session => {
                        let log = logTotalsBySession[session.id];
                        if (log) {
                            session.recorded_minutes = log.minutes;
                            session.recorded_time = log.time;
                        }
                    });
                });
            }
        },
        mounted() {
            this.loadRegistration(true);
        }
    };
</script>

<style lang="scss" scoped>
    .video-frame {
        border-radius: 5px;
        border: 1px solid #e7e7e7;
        padding: 10px;
        line-height: 0;
        width: 222px;
        height: 135px;


        img {
            max-width: 200px;
        }
    }
</style>

<style lang="scss">
    .session-progress .progress {
        height: 0.25rem !important;
    }
</style>
